export enum OnboardingStep {
    SetUp = 1,
    PricePlan = 2,
    CompanyInformation = 3,
    YourContactInformation = 4,
    PaymentAndAccountsSettings = 5,
    ConnectedToPensoPay = 6,
    OnboardingFailed = 7,
}

export interface OnboardingError {
    message: string;
    value: string;
}

export enum OnboardingErrorMessages {
    CUSTOMERPAYMENTS_CREATESETUP_GENERICERROR = 'CUSTOMERPAYMENTS_CREATESETUP_GENERICERROR',
    CUSTOMERPAYMENTS_VALIDATION_ERROR = 'CUSTOMERPAYMENTS_VALIDATION_ERROR',
}

// Mixpanel event constant for tracking onboarding pages
export const areaName = 'paymentlink';
export const actionName = 'onboarding-page';
